import React, { useContext, useEffect, useRef } from "react";
import "./sidebar.css";
import {
  Person,
  PersonAdd,
  Ballot,
  Equalizer,
  Home,
  ExitToApp,
  History,
  NoteAdd,
} from "@material-ui/icons";
import { Link, useHistory } from "react-router-dom";
import { Context } from "../../context/Context";

const Sidebar = () => {
  const history = useHistory();
  const { user, dispatch } = useContext(Context);
  const reservationUrl = useRef();
  const agentsList = useRef();
  const agentsNew = useRef();
  const settings = useRef();
  const historyPage = useRef();
  const newReservation = useRef();
  const handleLogout = () => {
    console.log("asd");
    window.sessionStorage.clear();
    history.push("/");
    dispatch({ type: "LOGOUT" });
  };
  console.log(window.location.pathname);
  useEffect(() => {
    reservationUrl.current.setAttribute("class", "");
    if (window.location.pathname === "/art-lot/agentslist") {
      agentsList.current.setAttribute("class", "active");
    } else if (window.location.pathname === "/art-lot/admin") {
      reservationUrl.current.setAttribute("class", "active");
    } else if (window.location.pathname === "/art-lot/agents/new") {
      agentsNew.current.setAttribute("class", "active");
    } else if (window.location.pathname === "/art-lot/dashboard") {
      settings.current.setAttribute("class", "active");
    } else if (window.location.pathname === "/art-lot/history") {
      historyPage.current.setAttribute("class", "active");
    } else if (window.location.pathname === "/art-lot/reservation/new") {
      newReservation.current.setAttribute("class", "active");
    }
  }, []);

  return (
    <div className="AdminWrapper">
      <div className="details">
        <p>PANEL {user.role === "admin" ? "ADMINA" : "AGENTA"}</p>
        <div className="avatar">
          <Person className="icon" />
        </div>
        <span>Art Lot</span>
        <hr style={{ color: "white" }} />
      </div>
      <div className="menu">
        <ul>
          <Link to="/admin" className="link">
            <li className="active" ref={reservationUrl}>
              <Ballot className="icon" /> <span>REZERWACJE</span>
            </li>
          </Link>
          {user.role === "admin" ? (
            <Link to="/agentslist" className="link">
              <li ref={agentsList}>
                <Person className="icon" /> <span>AGENCI</span>
              </li>
            </Link>
          ) : null}
          {user.role === "admin" ? (
            <Link to="/agents/new" className="link">
              <li ref={agentsNew}>
                <PersonAdd className="icon" /> <span>DODAJ AGENTA</span>
              </li>
            </Link>
          ) : null}
          {user ? (
            <Link to="/reservation/new" className="link">
              <li ref={newReservation}>
                <NoteAdd className="icon" /> <span>DODAJ REZERWACJE</span>
              </li>
            </Link>
          ) : null}
          {user.role === "admin" ? (
            <Link to="/dashboard" className="link">
              <li ref={settings}>
                <Equalizer className="icon" /> <span>STATYSTYKI</span>
              </li>
            </Link>
          ) : null}
          <Link to="/history" className="link">
            <li ref={historyPage}>
              <History className="icon" /> <span>HISTORIA</span>
            </li>
          </Link>
          <Link to="/" className="link">
            <li>
              <Home className="icon" />
              <span>HOME PAGE</span>
            </li>
          </Link>
        </ul>
      </div>
      <div className="logout">
        <ExitToApp className="icon" onClick={handleLogout} />
        <span onClick={handleLogout}>WYLOGUJ</span>
      </div>
    </div>
  );
};

export default Sidebar;
